/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { Flex } from '@getgo/chameleon-chakra-ui';
import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { SessionContext } from '../../context/SessionContext';
import {
  TelemetryAction,
  TelemetryComponent,
  TelemetryState,
  useSendTelemetry,
} from '../../hooks/useSendTelemetry';
import { reloadPageWithSessionTrackingId } from '../../services/NavigatorService';
import { Spacing } from '../../themes/GoToTheme';
import { GoToLink } from '../Link/GoToLink';
import { GoToText } from '../Texts/GoToText';

const messages = defineMessages({
  caption: {
    id: 'goto.ongoing.troubleshooting',
  },
  redownload: {
    id: 'goto.downloadInstructions.troubleshooting.tryAgainLink',
  },
});

interface Props {
  telemetryState: TelemetryState;
  caption?: String;
}

export const InstallTroubleshooting: React.FC<Props> = ({
  telemetryState,
  caption,
}) => {
  const { formatMessage: f } = useIntl();
  const { sessionTrackingId, meetingId } = useContext(SessionContext);
  const sendTelemetry = useSendTelemetry();
  return (
    <Flex direction='row' marginTop={Spacing.CoreLayout3}>
      <GoToText marginRight={2}>{caption || f(messages.caption)}</GoToText>
      <GoToLink
        href=''
        onClick={() => {
          sendTelemetry(
            TelemetryComponent.Native,
            TelemetryAction.Retry,
            telemetryState
          );
          reloadPageWithSessionTrackingId(meetingId, sessionTrackingId);
        }}
      >
        {f(messages.redownload)}
      </GoToLink>
    </Flex>
  );
};
